"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDnd = require("react-dnd");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _forEach2 = _interopRequireDefault(require("lodash/forEach"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _throttle2 = _interopRequireDefault(require("lodash/throttle"));

var _config = require("./config.js");

var _document = _interopRequireDefault(require("./document.png"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var timeouts = {};

var clearTimeouts = function clearTimeouts() {
  // Clear all timeouts
  (0, _forEach2.default)(timeouts, function (timeout, key) {
    clearTimeout(timeout);
    delete timeouts[key];
  });
};

var source = {
  beginDrag: function beginDrag(props, monitor, component) {
    return {
      element: props.element
    };
  }
};
var target = {
  hover: (0, _throttle2.default)(function (props, monitor, component) {
    var element = props.element,
        toggleCollapsedElementState = props.toggleCollapsedElementState; // Determine rectangle on screen

    var hoverBoundingRect = _reactDom.default.findDOMNode(component).getBoundingClientRect(); // Get horizontal middle


    var hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    var hoverLowQuarterY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 4;
    var hoverHighQuarterY = (hoverBoundingRect.bottom - hoverBoundingRect.top) * 3 / 4; // Determine mouse position

    var clientOffset = monitor.getClientOffset(); // Get pixels to the top

    var hoverClientY = clientOffset.y - hoverBoundingRect.top;
    var middle = hoverClientY >= hoverLowQuarterY && hoverClientY <= hoverHighQuarterY;
    var hoveredElement = {
      id: element.id,
      top: hoverClientY < hoverMiddleY,
      middle: middle,
      bottom: hoverClientY >= hoverMiddleY
    };
    var prevHoveredElement = (0, _pick2.default)(props.hoveredElement, ['id', 'top', 'middle', 'bottom']);

    if (!(0, _isEqual2.default)(prevHoveredElement, hoveredElement)) {
      props.hoverElement(hoveredElement);
    }

    if (props.isCollapsed) {
      if (middle && !timeouts[element.id]) {
        timeouts[element.id] = setTimeout(function () {
          toggleCollapsedElementState(element.id);
        }, _config.HOVER_EXPAND_WAITING);
      }

      if (!middle) {
        clearTimeouts();
      }
    }
  }, 1000 / 30, {
    trailing: false
  }),
  drop: function drop(props, monitor, component) {
    clearTimeouts();
  }
};

function collectTarget(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget()
  };
}

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

var Element = /*#__PURE__*/function (_React$Component) {
  _inherits(Element, _React$Component);

  var _super = _createSuper(Element);

  function Element() {
    var _this;

    _classCallCheck(this, Element);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_toggleCollapsedElementState", function () {
      _this.props.toggleCollapsedElementState(_this.props.element.id);
    });

    _defineProperty(_assertThisInitialized(_this), "_getElement", function () {
      var _this$props = _this.props,
          element = _this$props.element,
          isDragging = _this$props.isDragging,
          isCollapsed = _this$props.isCollapsed,
          connectDragSource = _this$props.connectDragSource,
          collapsedIndent = _this$props.collapsedIndent,
          isPlaceholderParent = _this$props.isPlaceholderParent;

      if (isDragging) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          paddingLeft: "".concat((element.level - 1) * _this.props.indentSize, "px")
        }
      }, connectDragSource( /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.elementWrapper,
        style: {
          marginLeft: "".concat(collapsedIndent, "px")
        }
      }, element.isAdult && element.children && element.children.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.collapsed,
        onClick: _this._toggleCollapsedElementState
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "glyphicon glyphicon-triangle-".concat(isCollapsed ? 'right' : 'bottom')
      })), element.isAdult && (!element.children || element.children.length === 0) && /*#__PURE__*/_react.default.createElement("div", {
        className: _style.default.collapsed + ' ' + _style.default.disabled
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "glyphicon glyphicon-triangle-bottom"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: isPlaceholderParent ? _style.default.placeholderParent : ''
      }, element.component))));
    });

    return _this;
  }

  _createClass(Element, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var img = new Image();
      img.src = _document.default;

      img.onload = function () {
        return _this2.props.connectDragPreview(img);
      };
    }
  }, {
    key: "render",
    value: function render() {
      var connectDropTarget = this.props.connectDropTarget;
      return connectDropTarget( /*#__PURE__*/_react.default.createElement("div", {
        style: {
          position: 'relative'
        }
      }, this._getElement()));
    }
  }]);

  return Element;
}(_react.default.Component);

_defineProperty(Element, "propTypes", {
  connectDropTarget: _propTypes.default.func.isRequired,
  connectDragSource: _propTypes.default.func.isRequired,
  connectDragPreview: _propTypes.default.func.isRequired,
  isDragging: _propTypes.default.bool.isRequired,
  element: _propTypes.default.object,
  indentSize: _propTypes.default.number,
  isCollapsed: _propTypes.default.bool,
  hoveredElement: _propTypes.default.object,
  hoverElement: _propTypes.default.func,
  toggleCollapsedElementState: _propTypes.default.func,
  collapsedIndent: _propTypes.default.number,
  isPlaceholderParent: _propTypes.default.bool
});

var _default = (0, _reactDnd.DropTarget)(function (props) {
  return props.dragDropType;
}, target, collectTarget)((0, _reactDnd.DragSource)(function (props) {
  return props.dragDropType;
}, source, collectSource)(Element));

exports.default = _default;